
import { defineComponent } from "vue";
import { ILocation, RiskScoreViewer } from "@/types";

import {
  useGammaData,
  useGammaWebServices,
  useLayout,
  useLocation,
  useMap,
  useOrgSettings,
} from "@/services";
import { mapState } from "pinia";

export default defineComponent({
  name: "LocationActionbar",
  props: {
    position: {
      type: String,
      default: "",
    },
  },
  computed: {
    ...mapState(useLayout, ["isBottomDrawerOpen"]),
    ...mapState(useMap, ["mapPosition"]),
    ...mapState(useLocation, ["isSaved", "location"]),
    ...mapState(useOrgSettings, ["showRiskDetails"]),
    ...mapState(useGammaData, ["hasPrecisionAccuracy"]),
    actions(): any[] {
      return [
        {
          icon: "share-fill",
          title: "Share link",
          action: this.openShareLinkModal,
        },
        {
          icon: "card-image",
          title: "Street view",
          action: this.openStreetViewModal,
        },

        ...(this.showRiskDetails
          ? [
              {
                icon: this.isBottomDrawerOpen
                  ? "arrows-angle-contract"
                  : "arrows-angle-expand",
                title: this.isBottomDrawerOpen
                  ? "Close drawer"
                  : "Expand drawer",
                action: this.toggleDrawer,
              },
            ]
          : []),
        {
          icon: this.isSaved ? "star-fill" : "star",
          title: "Saved searches",
          action: () =>
            this.isSaved ? this.removeLocation() : this.saveLocation(),
        },
        {
          icon: "file-earmark-arrow-down",
          title: "Download PDF",
          action: this.startPrinter,
          disabled: () => !this.riskEntries.length,
        },
      ];
    },
    currentHref(): string {
      return this.$route.fullPath;
    },
    riskEntries(): RiskScoreViewer[] {
      return useGammaWebServices().allRisks || [];
    },
  },
  methods: {
    toggleDrawer() {
      useLayout().isBottomDrawerOpen = !useLayout().isBottomDrawerOpen;
    },
    openShareLinkModal() {
      this.$bvModal.show("share-link-modal");
    },
    async openStreetViewModal() {
      this.$bvModal.show("street-view-modal");
    },

    saveLocation() {
      if (this.location) {
        useLocation().save(this.location._data as ILocation);
      }
    },
    removeLocation() {
      if (this.location) {
        useLocation().remove(this.location._data as ILocation);
      }
    },
    startPrinter() {
      this.$bvModal.show("print-view");
    },
  },
});
